<template>
  <div
    id="app"
    @scroll="domScroll"
    :style="{
      'padding-top': isMobile ? '62px' : 0
    }"
  >
    <router-view />
    <tip-success ref="tipSuccess"></tip-success>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      abb: '1'
    }
  },
  methods: {
    ...mapMutations(['setAppScroll']),
    domScroll(e) {
      const domTop = document.getElementById('app').scrollTop
      if (domTop > 65) {
        if (this.appScroll !== true) this.setAppScroll(true)
      } else {
        if (this.appScroll !== false) this.setAppScroll(false)
      }
    },
    iniTtipSuccess() {
      this.$refs.tipSuccess.init()
    }
  },
  computed: {
    ...mapState(['appScroll', 'isMobile'])
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init(to, from)
    })
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    next()
  }
}
</script>

<style>
#app {
  height: 100%;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue